import { Alert, AlertTitle, Box } from '@mui/material';
import type { ReactNode } from 'react';
import type { ApiError } from '@/api/errors';
import { useCopy } from '@/hooks/useCopy';

export interface ErrorBannerProps {
  message?: string | null;
  title?: string;
  error?: ApiError | null;
  requestId?: string | null;
  action?: ReactNode;
}

export function ErrorBanner({ message, title, error, requestId, action }: ErrorBannerProps) {
  const { t } = useCopy();
  if (!message && !error) return null;
  const code = error?.code;
  const errorMessage =
    message ??
    (code
      ? t(`errors.codes.${code}`, error?.details?.message ?? code)
      : t('errors.generic', 'Something went wrong.'));
  const finalRequestId = requestId ?? error?.requestId ?? null;
  return (
    <Box data-testid="error-banner" sx={{ mb: 2 }}>
      <Alert severity="error" action={action}>
        {title ? <AlertTitle>{title}</AlertTitle> : null}
        {errorMessage}
        {finalRequestId ? (
          <Box component="span" sx={{ display: 'block', fontSize: '0.75rem', opacity: 0.8, mt: 0.5 }}>
            {t('common.reference', 'Reference')}: {finalRequestId}
          </Box>
        ) : null}
      </Alert>
    </Box>
  );
}
